import {AttendeePermission, Maybe} from '../../schema';

export default class AttendeePermissions {

  edit = false
  delete = false
  updatePayment = false
  updateParticipation = false
  manageEvaluation = false
  generateCertificate = false

  hasAny = false
  full = false

  constructor(permissions?: Maybe<ReadonlyArray<Maybe<AttendeePermission>>>) {
    if (!permissions) {
      return;
    }

    this.full = permissions.includes(AttendeePermission.Full)

    this.hasAny = permissions.length > 0

    this.edit = this.full || permissions.includes(AttendeePermission.Edit)
    this.delete = this.full || permissions.includes(AttendeePermission.Delete)
    this.updatePayment = this.full || permissions.includes(AttendeePermission.UpdatePayment)
    this.updateParticipation = this.full || permissions.includes(AttendeePermission.UpdateParticipation)
    this.manageEvaluation = this.full || permissions.includes(AttendeePermission.ManageEvaluation)
    this.generateCertificate = this.full || permissions.includes(AttendeePermission.GenerateCertificate)
  }

}
